var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9c32010f5b68a6ed95930a4d4c1c6c98cc577d61"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yunnanzhiye-pc-web"]={id:"9c32010f5b68a6ed95930a4d4c1c6c98cc577d61"};
      